module.exports = __webpack_public_path__ + "img/part3-2.b151ef76.png";